module.exports = __webpack_public_path__ + "8655379b88afb096ae09dfcc4ea3ec5e.pdf";